import SoftBox from "../../components/SoftBox";
import SoftInput from "../../components//SoftInput";
import SoftButton from "../../components/SoftButton";

// Authentication layout components
import IllustrationLayout from "../../examples/LayoutContainers/IllustrationLayout";

// Image
import { useForm } from "react-hook-form";
import { useSignIn } from "./useAuth";
import React, { useEffect } from "react";
import { removeToken } from "../../utils/cache";
import { useNavigate } from "react-router-dom";
import { toastError } from "../../utils/toast";

function SignIn() {
  const { register, handleSubmit } = useForm({ defaultValues: { email: "", password: "" } });
  const navigate = useNavigate();
  useEffect(() => {
    removeToken();
  }, []);

  const { mutate, isLoading } = useSignIn();

  const handleSubmitForm = (values) => {
    mutate(values, {
      onError: () => {
        toastError({
          description: `Invalid email or password!`,
        });
      },
    });
  };

  return (
    <IllustrationLayout title="Sign In" description="Enter your email and password to sign in">
      <SoftBox
        component="form"
        role="form"
        onSubmit={handleSubmit(handleSubmitForm)}
        sx={({ palette }) => ({
          // Keep saved credentials on the same white surface as manually entered values.
          "& input:autofill, & input:-webkit-autofill": {
            boxShadow: `0 0 0 1000px ${palette.white.main} inset`,
            WebkitTextFillColor: palette.text.primary,
            caretColor: palette.text.primary,
          },
        })}
      >
        <SoftBox mb={2}>
          <SoftInput type="email" placeholder="Email" size="large" {...register("email")} />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftInput
            type="password"
            placeholder="Password"
            size="large"
            {...register("password")}
          />
        </SoftBox>
        <SoftBox sx={{ display: "flex", justifyContent: "end" }}>
          <SoftButton
            variant="text"
            color="dark"
            fontWeight="medium"
            sx={{
              py: "0px!important",
              paddingRight: "0px!important",
              "&:hover": {
                backgroundColor: "transparent!important",
                textDecoration: "underline",
              },
            }}
            onClick={() => {
              navigate("/forgot-password");
            }}
          >
            Forgot password?
          </SoftButton>
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton
            variant="gradient"
            color="info"
            size="large"
            fullWidth
            type="submit"
            disabled={isLoading}
            isLoading={isLoading}
          >
            Sign In
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </IllustrationLayout>
  );
}

export default SignIn;
